module.exports = __webpack_public_path__ + "static/media/store_bg.e2cf8146.svg";